import book_1 from '../assets/books/book_1.jpg';
import book_2 from '../assets/books/book_2.jpg';
import book_3 from '../assets/books/book_3.jpg';
import book_4 from '../assets/books/book_4.jpg';
import book_5 from '../assets/books/book_5.jpg';
import book_6 from '../assets/books/book_6.jpg';
import book_7 from '../assets/books/book_7.jpg';
import book_8 from '../assets/books/book_8.jpg';
import book_9 from '../assets/books/book_9.jpg';
import book_10 from '../assets/books/book_10.jpg';
import book_11 from '../assets/books/book_11.jpg';
import book_12 from '../assets/books/book_12.jpg';
import book_13 from '../assets/books/book_13.jpg';
import book_14 from '../assets/books/book_14.jpg';
import book_15 from '../assets/books/book_15.jpg';
import book_16 from '../assets/books/book_16.jpg';

export const booksData = [
  {
    author: 'Colleen Hoover',
    title: 'It Starts With Us',
    image: `${book_1}`,
  },

  {
    author: 'Prince Harry',
    title: 'Spare',
    image: `${book_2}`,
  },

  {
    author: 'Jeff Kinney',
    title: 'Diary of a Wimpy Kid - Diper Överlöde',
    image: `${book_3}`,
  },

  {
    author: 'Ina Garten',
    title: 'Go-To Dinners',
    image: `${book_4}`,
  },

  {
    author: 'Matthew Perry',
    title: 'Friends, Lovers, and the Big Terrible Thing',
    image: `${book_5}`,
  },

  {
    author: 'Colleen Hoover',
    title: 'It Ends With Us',
    image: `${book_6}`,
  },

  {
    author: 'Rush Limbaugh',
    title: "Radio's Greatest of All Time",
    image: `${book_7}`,
  },

  {
    author: 'Colleen Hoover',
    title: 'Verity',
    image: `${book_8}`,
  },

  {
    author: 'James Clear',
    title: 'Atomic Habits',
    image: `${book_9}`,
  },

  {
    author: 'George R. R. Martin',
    title: 'The Rise of the Dragon',
    image: `${book_10}`,
  },

  {
    author: 'John Grisham',
    title: 'Boys From Biloxi',
    image: `${book_11}`,
  },

  {
    author: 'George R. R. Martin',
    title: 'Fire & Blood',
    image: `${book_12}`,
  },

  {
    author: 'Ted Cruz',
    title: 'Justice Corrupted',
    image: `${book_13}`,
  },

  {
    author: 'Jennette McCurdy',
    title: "I'm Glad My Mom Died",
    image: `${book_14}`,
  },

  {
    author: 'Colleen Hoover',
    title: 'Reminders of Him',
    image: `${book_15}`,
  },

  {
    author: 'Edward Powys Mathers',
    title: "Cain's Jawbone",
    image: `${book_16}`,
  },
];
